import { Component, TemplateRef, Input, OnDestroy, OnInit, OnChanges, ChangeDetectorRef, SimpleChanges, ChangeDetectionStrategy } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { Subscription } from "rxjs/Subscription";
import { BaseModel } from "@ngx-resource-toolkit/core";



@Component({
    selector: 'loader',
    templateUrl: './loader.component.html',
    // changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaderComponent implements OnInit, OnChanges, OnDestroy {

    @Input() model: BaseModel;
    @Input() loading: boolean;
    @Input() erreur: string;
    @Input() contentTemplate: TemplateRef<any>;
    @Input() cssClass: string;

    constructor() {

    }

    ngOnInit(): void {
        console.log('LoaderComponent', 'ngOnInit')
    }

    ngOnChanges(changes: SimpleChanges): void {
        console.log('LoaderComponent', 'ngOnChanges', changes);
        // this.cd.detectChanges()
    }

    ngOnDestroy(): void {
        console.log('LoaderComponent', 'ngOnDestroy')
    }

}


// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/shared/miscellaneous/loader.component.ts